import React from 'react';
import {
  Card,
  Input,
  Button,
  Space,
  Typography,
  Row,
  Col,
  Empty,
  Popconfirm
} from 'antd';
import {
  DeleteOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined
} from '@ant-design/icons';

const { Text } = Typography;
const { TextArea } = Input;

const JourneyNodeManager = ({
  nodes = [],
  onUpdateNode,
  onDeleteNode,
  onMoveNode,
  editable = false
}) => {
  // 更新阶段字段
  const handleFieldChange = (nodeId, field, value) => {
    if (onUpdateNode) {
      onUpdateNode(nodeId, { [field]: value });
    }
  };

  // 向上移动
  const handleMoveUp = (index) => {
    if (index > 0 && onMoveNode) {
      onMoveNode(index, index - 1);
    }
  };

  // 向下移动
  const handleMoveDown = (index) => {
    if (index < nodes.length - 1 && onMoveNode) {
      onMoveNode(index, index + 1);
    }
  };

  if (nodes.length === 0) {
    return (
      <Empty
        description="暂无阶段"
        style={{ margin: '40px 0' }}
      />
    );
  }

  return (
    <div>
      {nodes.map((node, index) => (
        <Card
          key={node.id || index}
          size="small"
          style={{ marginBottom: 16 }}
          title={
            <Space>
              <Text strong>阶段 {node.nodeOrder || index + 1}</Text>
              {node.nodeName && <Text type="secondary">- {node.nodeName}</Text>}
            </Space>
          }
          extra={
            editable && (
              <Space>
                <Button
                  type="text"
                  size="small"
                  icon={<ArrowUpOutlined />}
                  disabled={index === 0}
                  onClick={() => handleMoveUp(index)}
                />
                <Button
                  type="text"
                  size="small"
                  icon={<ArrowDownOutlined />}
                  disabled={index === nodes.length - 1}
                  onClick={() => handleMoveDown(index)}
                />
                <Popconfirm
                  title="确定要删除这个阶段吗？"
                  onConfirm={() => onDeleteNode(node.id)}
                  okText="确定"
                  cancelText="取消"
                >
                  <Button
                    type="text"
                    size="small"
                    danger
                    icon={<DeleteOutlined />}
                  />
                </Popconfirm>
              </Space>
            )
          }
        >
          <Row gutter={16}>
            <Col span={12}>
              <div style={{ marginBottom: 12 }}>
                <Text strong>阶段名称</Text>
                <Text style={{ color: '#ff4d4f', marginLeft: 4 }}>*</Text>
              </div>
              {editable ? (
                <Input
                  placeholder="请输入阶段名称"
                  value={node.nodeName}
                  onChange={(e) => handleFieldChange(node.id, 'nodeName', e.target.value)}
                />
              ) : (
                <Text>{node.nodeName || '-'}</Text>
              )}
            </Col>
          </Row>


          {!editable && (
            <Row gutter={16} style={{ marginTop: 16 }}>
              <Col span={8}>
                <Text type="secondary">标签名称: </Text>
                <Text>{node.tagName || '未创建'}</Text>
              </Col>
              <Col span={8}>
                <Text type="secondary">同步状态: </Text>
                <Text type={node.syncStatus ? 'success' : 'warning'}>
                  {node.syncStatus ? '已同步' : '未同步'}
                </Text>
              </Col>
              <Col span={8}>
                <Text type="secondary">阶段状态: </Text>
                <Text type={node.status === 'active' ? 'success' : 'secondary'}>
                  {node.statusName || node.status || '-'}
                </Text>
              </Col>
            </Row>
          )}
        </Card>
      ))}
    </div>
  );
};

export default JourneyNodeManager;